import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const BuildingFill = memo((props: IconProps) => {
    const { color = "var(--header)", ...rest } = props
    return (
        <svg width={24} height={24} viewBox="0 0 22 18" fill="none" {...rest}>
            <path
                fill={color}
                d="M20 16H22V18H0V16H2V1C2 0.734784 2.10536 0.48043 2.29289 0.292893C2.48043 0.105357 2.73478 0 3 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V16H16V6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V16ZM6 8V10H10V8H6ZM6 4V6H10V4H6Z"
            />
        </svg>
    )
})

export default BuildingFill
